import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo_iosi_blue.png'


const _withScopeId = n => (_pushScopeId("data-v-80294a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-schedule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo iosi"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, "© " + _toDisplayString(_ctx.getYearToday()) + " - " + _toDisplayString(_ctx.$t("landingPage.copyright")), 1)
  ]))
}